export default "__VITE_ASSET__63dee11e__"